import { Component, Injector, Input } from '@angular/core';
import { AppComponentBase } from '../../app-component-base';

export interface StepData {
  label: string;
  isCompleted?: boolean;
  isCurrent?: boolean;
}

export enum StepStatus {
  Completed = 'completed',
  Current = 'current',
  Pending = 'pending',
}

@Component({
  selector: 'app-delivery-step-progress',
  templateUrl: './delivery-step-progress.component.html',
  styleUrls: ['./delivery-step-progress.component.scss'],
})
export class DeliveryStepProgressComponent extends AppComponentBase {
  @Input() currentStepIndex: number = 0;
  stepData: StepData[] = [
    { label: this.L('::Delivery:Checkpoint:Shipped') },
    { label: this.L('::Delivery:Checkpoint:InTransit') },
    { label: this.L('::Delivery:Checkpoint:OutForDelivery') },
    { label: this.L('::Delivery:Checkpoint:Delivered') },
  ];

  constructor(injector: Injector) {
    super(injector);
  }

  getStepStatus(index: number): StepStatus {
    if (index < this.currentStepIndex) {
      return StepStatus.Completed;
    } else if (index === this.currentStepIndex) {
      return StepStatus.Current;
    } else {
      return StepStatus.Pending;
    }
  }

  isStepActive(index: number): boolean {
    return index <= this.currentStepIndex;
  }

  isLineCompleted(index: number): boolean {
    return index < this.currentStepIndex;
  }

  trackByIndex(index: number): number {
    return index;
  }
}
